import { render, staticRenderFns } from "./clientOtherMsg.vue?vue&type=template&id=5059f5a4&scoped=true"
import script from "./clientOtherMsg.vue?vue&type=script&lang=js"
export * from "./clientOtherMsg.vue?vue&type=script&lang=js"
import style0 from "./clientOtherMsg.vue?vue&type=style&index=0&id=5059f5a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059f5a4",
  null
  
)

export default component.exports